export interface ToggleConfig {
    triggers: NodeListOf<HTMLElement>;
    target: HTMLElement;
}

export class Toggle {
    private readonly elements: {
        triggers: NodeListOf<HTMLElement>;
        target: HTMLElement;
    };
    protected isOpened: boolean;


    constructor({triggers, target}: ToggleConfig) {
        this.elements = {triggers, target};
        this.isOpened = target
            ? target.classList.contains(`is-opened`)
            : false;
        this.init();
    }

    public toggle(evt: Event): void {
        evt.preventDefault();
        const {triggers, target} = this.elements;
        const trigger = evt.currentTarget as HTMLElement;

        this.isOpened
            ? triggers.forEach(it => it.classList.remove(`is-opened`))
            : trigger.classList.toggle(`is-opened`);
        this.elements.target.classList.toggle(`is-opened`);
        this.isOpened = !this.isOpened;
    }

    protected init(): void {
        const {triggers, target} = this.elements;
        if (!triggers.length || !target) return;
        triggers.forEach(trigger => {
            trigger.addEventListener('click', (evt) => this.toggle(evt), false);
        });
    }
}